import { Terminal, Monitor } from "lucide-react";

export type ChatMode = "claude-code" | "cowork";

interface ChatModeSelectorProps {
  mode: ChatMode;
  onChange: (mode: ChatMode) => void;
}

export function ChatModeSelector({ mode, onChange }: ChatModeSelectorProps) {
  return (
    <div
      className="flex rounded-full border border-border bg-muted/50 p-0.5"
      role="radiogroup"
      aria-label="Modo do assistente"
    >
      <button
        type="button"
        role="radio"
        aria-checked={mode === "claude-code"}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          mode === "claude-code"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
        onClick={() => onChange("claude-code")}
      >
        <Terminal className="h-3 w-3" />
        Code
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={mode === "cowork"}
        className={`flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          mode === "cowork"
            ? "bg-background text-foreground shadow-sm"
            : "text-muted-foreground hover:text-foreground"
        }`}
        onClick={() => onChange("cowork")}
      >
        <Monitor className="h-3 w-3" />
        Cowork
      </button>
    </div>
  );
}
